<template>
  <v-dialog :value="sectionEditor.show" :width="1000" @input="handleClosePopup">
    <div style="background-color: #fff">
      <div class="header-modal">
        <v-card-title class="d-flex justify-space-between align-center" style="padding: 10px 0">
          <span style="color: #0081c7">{{ fields.title }}</span>
          <v-btn icon @click="handleClosePopup">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
      </div>

      <div class="pa-4">
        <label class="label-input">Section Name</label>
        <v-text-field v-model="fields.title" />

        <div class="mb-4">
          <div class="label-input">Layout</div>
          <div class="group-input">
            <v-row>
              <v-col cols="12" md="6">
                <div class="label-input-sub">Background color</div>
                <div class="d-flex align-center gap-3">
                  <input
                    style="width: 40px; height: 40px; margin-right: 12px"
                    type="color"
                    v-model="fields.styleSection.background"
                  />
                  <v-text-field class="mb-0 mt-0" v-model="fields.styleSection.background" hide-details />
                </div>
              </v-col>
              <v-col cols="12" md="6">
                <div class="label-input-sub">Text color</div>
                <div class="d-flex align-center gap-3">
                  <input
                    style="width: 40px; height: 40px; margin-right: 12px"
                    type="color"
                    v-model="fields.styleSection.textColor"
                  />
                  <v-text-field class="mb-0 mt-0" v-model="fields.styleSection.textColor" hide-details />
                </div>
              </v-col>
              <v-col cols="12" md="6">
                <v-checkbox
                  class="mb-0 mt-0"
                  v-model="fields.styleSection.topPadding"
                  label="Top Padding"
                  dense
                  hide-details
                />
              </v-col>
              <v-col cols="12" md="6">
                <v-checkbox
                  class="mb-0 mt-0"
                  v-model="fields.styleSection.bottomPadding"
                  label="Bottom Padding"
                  dense
                  hide-details
                />
              </v-col>
              <v-col cols="12" md="6">
                <v-checkbox
                  class="mb-3 mt-0"
                  v-model="fields.containerPage.enableStyle"
                  label="Enable container style"
                  dense
                  hide-details
                />
                <div v-if="fields.containerPage.enableStyle">
                  <div>
                    <label>Background color</label>
                    <div class="d-flex align-center gap-3">
                      <input
                        style="width: 40px; height: 40px; margin-right: 12px"
                        type="color"
                        v-model="fields.containerPage.background"
                      />
                      <v-text-field class="mb-0 mt-0" v-model="fields.containerPage.background" hide-details />
                    </div>
                  </div>
                </div>
              </v-col>
            </v-row>
          </div>
        </div>

        <div class="mb-4">
          <div class="label-input">Title Card</div>
          <div class="group-input">
            <v-checkbox class="mb-3 mt-0" v-model="fields.titleCard.show" label="Show title card" dense hide-details />
            <ckeditor :editor="editor" v-model="fields.titleCard.content" :config="editorConfig" />
          </div>
        </div>

        <div class="mb-4">
          <div class="label-input">Slider Settings</div>
          <div class="group-input">
            <v-row>
              <v-col cols="12" md="6">
                <label for="colPerView">Slides per view (desktop)</label>
                <v-text-field
                  class="mb-0 mt-0"
                  type="number"
                  v-model.number="fields.wrapItems.colPerView"
                  id="colPerView"
                  hide-details
                />
              </v-col>
              <v-col cols="12" md="6">
                <label for="spaceBetween">Space between (px)</label>
                <v-text-field
                  class="mb-0 mt-0"
                  type="number"
                  v-model.number="fields.wrapItems.spaceBetween"
                  id="spaceBetween"
                  placeholder="30"
                  hide-details
                />
              </v-col>
              <v-col cols="12" md="6">
                <div class="label-input-sub">Item background</div>
                <div class="d-flex align-center gap-3">
                  <input
                    style="width: 40px; height: 40px; margin-right: 12px"
                    type="color"
                    v-model="fields.wrapItems.itemBackground"
                  />
                  <v-text-field class="mb-0 mt-0" v-model="fields.wrapItems.itemBackground" hide-details />
                </div>
              </v-col>
              <v-col cols="12" md="6">
                <label for="itemBorderRadius">Item border radius (px)</label>
                <v-text-field
                  class="mb-0 mt-0"
                  type="number"
                  v-model.number="fields.wrapItems.itemBorderRadius"
                  id="itemBorderRadius"
                  placeholder="10"
                  hide-details
                />
              </v-col>
              <v-col cols="12" md="6">
                <div class="label-input-sub">Star color</div>
                <div class="d-flex align-center gap-3">
                  <input
                    style="width: 40px; height: 40px; margin-right: 12px"
                    type="color"
                    v-model="fields.wrapItems.colorStar"
                  />
                  <v-text-field class="mb-0 mt-0" v-model="fields.wrapItems.colorStar" hide-details />
                </div>
              </v-col>
            </v-row>
          </div>
        </div>

        <div class="d-flex justify-space-between align-center">
          <label class="label-input" style="margin: 0">Review Items</label>
          <v-btn small text color="primary" @click="handleAddItem">
            <v-icon size="16">mdi-plus</v-icon>
            <span>Add item</span>
          </v-btn>
        </div>
        <v-expansion-panels accordion>
          <v-expansion-panel v-for="(item, i) in fields.listItem" :key="i">
            <v-expansion-panel-header>
              <div class="d-flex justify-space-between align-center">
                <label>Item {{ i + 1 }}</label>
                <v-btn icon @click.stop="handleRemoveItem(i)">
                  <v-icon size="20" color="#ff6c6c">mdi-delete</v-icon>
                </v-btn>
              </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <div class="mb-3">
                <UploadImage
                  :image="{ imageSrc: item.image }"
                  :height="`300`"
                  :typeUpload="'image'"
                  @callback="obj => handleUploadImage(obj, i)"
                  @callbackDelete="handleRemoveUploadImage(i)"
                />
              </div>
              <div>
                <label>Link</label>
                <v-text-field v-model="item.link" hide-details />
              </div>

              <div class="mt-3 mb-2 label-input-sub">Rating</div>
              <div class="group-item">
                <v-checkbox class="mb-3 mt-0" v-model="item.rating.show" dense hide-details label="Show rating" />
                <div>
                  <label>Rating value</label>
                  <v-rating
                    color="warning"
                    background-color="#c1c1c1"
                    empty-icon="mdi-star-outline"
                    full-icon="mdi-star"
                    half-icon="mdi-star-half-full"
                    hover
                    length="5"
                    size="35"
                    v-model="item.rating.value"
                  ></v-rating>
                </div>
              </div>

              <div class="mt-3 mb-2 label-input-sub">Description</div>
              <div class="group-item">
                <v-row>
                  <v-col cols="12" md="12">
                    <v-checkbox
                      class="mb-0 mt-0"
                      v-model="item.description.show"
                      dense
                      hide-details
                      label="Show description"
                    />
                  </v-col>
                  <v-col cols="12" md="12">
                    <label>Text</label>
                    <ckeditor :editor="editor" v-model="item.description.text" :config="editorConfig" />
                  </v-col>
                </v-row>
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </div>

      <div class="footer-modal">
        <v-card-actions style="padding: 10px 0">
          <v-spacer></v-spacer>
          <v-btn min-width="100" depressed @click="handleClosePopup">Cancel</v-btn>
          <v-btn min-width="100" color="primary" @click="handleSave">Save</v-btn>
        </v-card-actions>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import UploadImage from '../common/form/upload-file/upload-image.vue';
import { updateHtmlFromData } from '../common/html/update';
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import { ckeditorConfigFullToolbar } from '@/helpers/editor';

export default {
  name: 'SliderItemBoxerSectionEditor',
  components: { UploadImage },
  props: {
    sectionEditor: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      editor: Editor,
      editorConfig: ckeditorConfigFullToolbar,
      fields: {
        title: 'Slider Item Boxer Section',
        styleSection: {
          topPadding: true,
          bottomPadding: true,
          background: '#FFFFFF',
          textColor: '#000000',
        },
        containerPage: {
          enableStyle: false,
          background: '#FFFFFF',
        },
        titleCard: {
          show: true,
          content: '<h2>Title</h2><p>Description</p>',
        },
        wrapItems: {
          colPerView: 3,
          spaceBetween: '30px',
          itemBackground: '#eff3fa',
          itemBorderRadius: '10px',
          colorStar: '#FFD700',
        },
        listItem: [],
      },
    };
  },
  mounted() {
    this.fields = {
      ...this.fields,
      ...this.sectionEditor.sectionExtract,
    };
  },
  methods: {
    handleUploadImage(obj, i) {
      this.fields.listItem[i].image = obj.imageSrc;
    },
    handleRemoveUploadImage(i) {
      this.fields.listItem[i].image = '';
    },
    handleAddItem() {
      this.fields.listItem.push({
        image: '',
        rating: { show: true, value: 4 },
        description: { show: true, text: '' },
      });
    },
    handleRemoveItem(i) {
      this.fields.listItem.splice(i, 1);
      if (!this.fields.listItem.length) {
        this.handleAddItem();
      }
    },
    handleClosePopup() {
      this.$emit('close');
    },
    handleSave() {
      const updateHtml = updateHtmlFromData.sectionSliderItemBoxer(this.sectionEditor.section.html, this.fields);
      this.$emit('update:section', {
        ...this.sectionEditor.section,
        title: this.fields.title,
        html: updateHtml,
      });
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>
.label-input {
  font-size: 18px !important;
  font-weight: 500;
  color: #000;
  margin-bottom: 2px;
  display: block;
}
.header-modal {
  position: sticky;
  top: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  padding: 0 16px;
  box-shadow: 0px 0px 12px #0000000f;
}
.footer-modal {
  position: sticky;
  padding: 0 16px;
  bottom: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  box-shadow: 0px 0px 12px #0000000f;
}
.v-expansion-panels {
  border: 1px solid #c1c1c1;
}
.v-expansion-panel::before {
  box-shadow: none;
}
.group-input {
  padding: 10px;
  border-radius: 8px;
  border: 1px solid #c1c1c1;
}
.group-item {
  padding: 10px;
  border-radius: 8px;
  border: 1px solid #e0e0e0;
}
</style>
